import React from "react"

import { Container } from "./styles"

const ErrorIcon = () => {
	return (
		<Container>
			<div class="error">
				<div class="error-x">
					<div class="error-left"></div>
					<div class="error-right"></div>
				</div>
				<div class="error-placeholder"></div>
				<div class="error-fix"></div>
			</div>
		</Container>
	)
}

export default ErrorIcon